import Thumb from './index.nativetv';

export default Thumb;
